var Flags = /** @class */ (function () {
    function Flags() {
    }
    return Flags;
}());
export { Flags };
